import React from "react";
import Text, { TextProps } from "./Text";

export type MultilineTextProps = Omit<TextProps, "children"> & {
  children: string | null | undefined;
};

export const MultilineText = ({ children, ...rest }: MultilineTextProps) => (
  <>
    {(children ?? "")
      .split("\n")
      .filter((x) => x.trim())
      .map((x) => (
        <Text {...(rest as any)} mb={1}>
          {x}
        </Text>
      ))}
  </>
);
